import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useReveal } from '../../hooks/useReveal';

const IMAGES = [
  {
    id: 'gallery-sensory',
    src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/t7o0ztri_0ad6546f-86f7-4b43-8e8f-977c3c21a0d4.JPG',
    alt: 'Estudiante feliz con proyecto sensorial'
  },
  {
    id: 'gallery-mural',
    src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/7vm405h7_1a22a3af-b9ab-475a-9193-e27a6405e384.JPG',
    alt: 'Estudiantes pintando un mural'
  },
  {
    id: 'gallery-costumes',
    src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/hk3dhf3o_87724a32-3c72-47d4-8672-c8a0ac1c08c6.JPG',
    alt: 'Estudiantes en proyecto cultural'
  }
];

const GalleryItem = ({ item, index }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${index * 80}ms` }}
      className="reveal relative aspect-[4/3] rounded-2xl overflow-hidden group cursor-pointer shadow-[0_8px_30px_rgb(0,0,0,0.06)]"
      data-testid={`gallery-item-${item.id}`}
    >
      <img
        src={item.src}
        alt={item.alt}
        className="w-full h-full object-cover object-center group-hover:scale-[1.08] transition-transform duration-700 ease-out"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
  );
};

export const HomeGalleryPreview = () => {
  const headerRef = useReveal();
  return (
    <section className="py-20 md:py-28" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div ref={headerRef} className="reveal text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Galería</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
            Cada día es una experiencia única
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {IMAGES.map((item, i) => <GalleryItem key={item.id} item={item} index={i} />)}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/galeria"
            className="inline-flex items-center gap-2 text-[#43b6b8] font-semibold hover:gap-3 transition-all"
          >
            Ver más fotos <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};
